import { render, staticRenderFns } from "./TitleAndSubtitle.vue?vue&type=template&id=6879e0d2&scoped=true&"
import script from "./TitleAndSubtitle.vue?vue&type=script&lang=js&"
export * from "./TitleAndSubtitle.vue?vue&type=script&lang=js&"
import style0 from "./TitleAndSubtitle.vue?vue&type=style&index=0&id=6879e0d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6879e0d2",
  null
  
)

export default component.exports